<template>
  <section class="research-cta-showcase">
    <div class="cta-background">
      <img :src="content.backgroundImage" alt="Research Background" class="cta-bg-image" />
      <div class="cta-overlay"></div>
    </div>
    
    <div class="container">
      <div class="cta-content">
        <div class="cta-header text-center">
          <div class="cta-badge">
            <i class="fas fa-handshake"></i>
            <span>{{ content.header.tag }}</span>
          </div>
          <h2>{{ content.header.title }}</h2>
          <p class="cta-description">{{ content.header.description }}</p>
        </div>
        
        <div class="cta-actions">
          <div class="cta-card collaborate-card wow fadeInLeft" v-for="(action, index) in content.actions" :key="index" :data-wow-delay="`${(index + 1) * 0.1}s`">
            <div class="cta-icon">
              <i :class="action.icon"></i>
            </div>
            <h3>{{ action.title }}</h3>
            <p>{{ action.description }}</p>
            <router-link :to="action.link" class="cta-btn" :class="action.buttonType">
              <i class="fas fa-arrow-right"></i>
              <span>{{ action.buttonText }}</span>
            </router-link>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'ResearchItsCtaComp',
  props: {
    content: {
      type: Object,
      required: true
    }
  }
}
</script>

<style scoped>
/* Import Google Fonts */
@import url('https://fonts.googleapis.com/css2?family=Archivo:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&family=Open+Sans:ital,wght@0,300;0,400;0,500;0,600;0,700;0,800;1,300;1,400;1,500;1,600;1,700;1,800&display=swap');

/* Research CTA Showcase Section */
.research-cta-showcase {
  padding: 120px 0;
  position: relative;
  overflow: hidden;
}

.cta-background {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 1;
}

.cta-bg-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.cta-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: linear-gradient(135deg, rgba(0, 0, 0, 0.8) 0%, rgba(26, 26, 46, 0.9) 100%);
}

.cta-content {
  position: relative;
  z-index: 2;
}

.cta-header {
  margin-bottom: 80px;
}

.cta-badge {
  display: inline-flex;
  align-items: center;
  gap: 10px;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  padding: 12px 24px;
  border-radius: 50px;
  font-size: 14px;
  font-weight: 600;
  letter-spacing: 1px;
  margin-bottom: 30px;
  box-shadow: 0 8px 32px rgba(102, 126, 234, 0.3);
}

.cta-badge i {
  font-size: 16px;
}

.cta-header h2 {
  font-size: 48px;
  font-weight: 700;
  color: white;
  margin-bottom: 20px;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

.cta-description {
  font-size: 18px;
  color: rgba(255, 255, 255, 0.8);
  max-width: 600px;
  margin: 0 auto;
  line-height: 1.6;
}

.cta-actions {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 40px;
  max-width: 800px;
  margin: 0 auto;
}

.cta-card {
  background: rgba(255, 255, 255, 0.05);
  border-radius: 20px;
  padding: 40px 30px;
  text-align: center;
  transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
  backdrop-filter: blur(10px);
  border: 1px solid rgba(255, 255, 255, 0.1);
  position: relative;
  overflow: hidden;
}

.cta-card::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: linear-gradient(135deg, rgba(102, 126, 234, 0.1), rgba(118, 75, 162, 0.1));
  opacity: 0;
  transition: opacity 0.4s ease;
}

.cta-card:hover::before {
  opacity: 1;
}

.cta-card:hover {
  transform: translateY(-10px);
  box-shadow: 0 25px 50px rgba(0, 0, 0, 0.3);
  border-color: rgba(102, 126, 234, 0.5);
}

.cta-icon {
  position: relative;
  z-index: 2;
  width: 80px;
  height: 80px;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto 30px;
  box-shadow: 0 10px 30px rgba(102, 126, 234, 0.3);
}

.cta-icon i {
  font-size: 32px;
  color: white;
}

.cta-card h3 {
  position: relative;
  z-index: 2;
  color: white;
  font-size: 24px;
  font-weight: 700;
  margin-bottom: 15px;
}

.cta-card p {
  position: relative;
  z-index: 2;
  color: rgba(255, 255, 255, 0.8);
  font-size: 16px;
  line-height: 1.6;
  margin-bottom: 30px;
}

.cta-btn {
  position: relative;
  z-index: 2;
  display: inline-flex;
  align-items: center;
  gap: 10px;
  padding: 15px 30px;
  border-radius: 50px;
  font-size: 16px;
  font-weight: 600;
  text-decoration: none;
  transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
  border: 2px solid transparent;
}

.cta-btn.primary-btn {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  box-shadow: 0 8px 32px rgba(102, 126, 234, 0.3);
}

.cta-btn.primary-btn:hover {
  transform: translateY(-3px);
  box-shadow: 0 15px 40px rgba(102, 126, 234, 0.4);
}

.cta-btn.secondary-btn {
  background: transparent;
  color: #667eea;
  border-color: #667eea;
}

.cta-btn.secondary-btn:hover {
  background: #667eea;
  color: white;
  transform: translateY(-3px);
  box-shadow: 0 15px 40px rgba(102, 126, 234, 0.3);
}

/* Responsive Design */
@media (max-width: 768px) {
  .cta-header h2 {
    font-size: 36px;
  }
  
  .cta-actions {
    grid-template-columns: 1fr;
  }
  
  .research-cta-showcase {
    padding: 80px 0;
  }
}
</style>
